import { render } from "./PlantillasImprimibles.vue?vue&type=template&id=7b8ced84&scoped=true"
import script from "./PlantillasImprimibles.vue?vue&type=script&lang=js"
export * from "./PlantillasImprimibles.vue?vue&type=script&lang=js"

import "./PlantillasImprimibles.vue?vue&type=style&index=0&id=7b8ced84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8ced84"]])

export default __exports__